var React = require('react');

function Leaf (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M43.9999 80C36.9762 80.0213 30.2009 77.402 25.018 72.6617C19.835 67.9213 16.623 61.4062 16.0189 54.4084C15.4147 47.4107 17.4627 40.4414 21.7565 34.883C26.0504 29.3245 32.2764 25.5828 39.1999 24.4C61.9999 20 67.9999 17.92 75.9999 8C79.9999 16 83.9999 24.72 83.9999 40C83.9999 62 64.8799 80 43.9999 80Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 84C8 72 15.4 62.56 28.32 60C38 58.08 48 52 52 48","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Leaf.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Leaf;

Leaf.default = Leaf;
